import React from 'react';

const ThumbsUp = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.99935 14H11.9993C12.5527 14 13.026 13.6666 13.226 13.1866L15.2393 8.48663C15.2993 8.33329 15.3327 8.17329 15.3327 7.99996V6.66663C15.3327 5.93329 14.7327 5.33329 13.9993 5.33329H9.79268L10.426 2.28663L10.446 2.07329C10.446 1.79996 10.3327 1.54663 10.1527 1.36663L9.44602 0.666626L5.05268 5.05996C4.81268 5.29996 4.66602 5.63329 4.66602 5.99996V12.6666C4.66602 13.4 5.26602 14 5.99935 14ZM5.99935 5.99996L8.89268 3.10663L7.99935 6.66663H13.9993V7.99996L11.9993 12.6666H5.99935V5.99996ZM0.666016 5.99996H3.33268V14H0.666016V5.99996Z'
        fill='#FEA82F'
      />
    </svg>
  );
};

export default ThumbsUp;
